module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "itembank"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/content/itembank'
      }
    }
  }, [_vm._v("Content")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Import Itembank Gratis")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Import Itembank")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "display": "flex",
      "flex-flow": "column"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.errorParse) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _vm._m(1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "display": "flex",
      "align-items": "flex-start"
    }
  }, [_vm._v("Upload File JSON")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    ref: "file",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange()
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-md",
    staticStyle: {
      "max-width": "200px",
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.file.click()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-file"
  }), _vm._v(" Pilih File JSON")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Masukkan file dalam format JSON")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [(!_vm.isReadable) ? _c('button', {
    staticClass: "btn btn-info btn-md pull-right",
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.itembanks.length > 0
    },
    on: {
      "click": function($event) {
        return _vm.previewJSON()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-table"
  }), _vm._v(" Preview")]) : _vm._e()])]), _vm._v(" "), (_vm.itembanks.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b', [_vm._v(_vm._s(_vm.viewMapel))])])]) : _vm._e(), _vm._v(" "), (_vm.itembanks.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b', [_vm._v(_vm._s(_vm.viewJenjang))])])]) : _vm._e(), _vm._v(" "), (_vm.itembanks.length > 0) ? _c('div', {
    staticStyle: {
      "padding-top": "20px",
      "padding-bottom": "10px"
    }
  }, [_c('app-datatable', {
    attrs: {
      "items": _vm.itembanks,
      "headers": _vm.headers,
      "has-action": true,
      "has-custom-pagination": false,
      "has-custom-search": false,
      "has-search-power": false
    },
    on: {
      "deleted": function($event) {
        return _vm.deleteItem($event)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-md",
    staticStyle: {
      "max-width": "300px",
      "float": "right",
      "margin": "10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submitImport()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-download"
  }), _vm._v(" Import")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-md",
    staticStyle: {
      "max-width": "300px",
      "float": "right",
      "margin": "10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.cancelImport()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-close"
  }), _vm._v(" Batal")])], 1) : _vm._e()])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Import Itembank")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticStyle: {
      "text-decoration": "none"
    }
  }, [_c('li', [_vm._v("File tidak bisa dibaca")]), _vm._v(" "), _c('li', [_vm._v("Pastikan jenis file (.JSON / .json)")]), _vm._v(" "), _c('li', [_vm._v("Format JSON tidak valid")]), _vm._v(" "), _c('li', [_vm._v("Atau "), _c('a', {
    staticStyle: {
      "color": "red",
      "text-decoration": "revert"
    },
    attrs: {
      "href": "https://codebeautify.org/jsonviewer",
      "target": "_blank"
    }
  }, [_vm._v("Periksa text JSON anda disini")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-1"
  }, [_c('b', [_vm._v(" Mapel : ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-1"
  }, [_c('b', [_vm._v("Jenjang: ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-90936d8e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home_setting/free_itembank/ItemBankImport.vue
// module id = 1378
// module chunks = 0